import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';

@Injectable({
  providedIn: 'root'
})
export class GetConfigShippingService {

  constructor() {
  }
  getShippingsConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigShippingFilter()
      ]
    }
  }

  getConfigShippingFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_TYPE',
          controlName: ['type', 'id'],
          placeholder: 'GENERIC_TYPE',
          data: 'typeOfShipping',
          options: {
            show: true,
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'TYPE_OF_SHIPPING_TRANSPORTER',
          controlName: ['transporterName', 'id'],
          placeholder: 'TYPE_OF_SHIPPING_TRANSPORTER',
          data: 'transporters',
          options: {
            show: true,
            value: 'name',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'input',
          label: 'ORDERS_LIST_SHIPPING_TRACKING',
          controlName: ['tracking'],
          placeholder: 'ORDERS_LIST_SHIPPING_TRACKING',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'TYPE_OF_SHIPPING_SITE_NAME',
          controlName: ['siteName'],
          placeholder: 'TYPE_OF_SHIPPING_SITE_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'datePicker',
          label: 'ORDERS_LIST_FILTER_PICKUP_DATE',
          controlName: ['pickupDate'],
          placeholder: 'ORDERS_LIST_PICKUP_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          controlName: ['deliveryDate'],
          placeholder: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'ORDERS_LIST_SHIPPING_DELIVERY_STATUS',
          controlName: ['deliveryStatus'],
          placeholder: 'ORDERS_LIST_SHIPPING_DELIVERY_STATUS',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_ORDER',
          controlName: ['orderId'],
          placeholder: 'GENERIC_ORDER',
          presentation: 'filter',
          options: {
            show: true
          }
        }
      ]
    }
  }

  getConfigShippingMisc(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: '',
          controlName: ['commentsBlog'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'textarea',
          label: '',
          controlName: ['comments'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            rows: 10,
          }
        }
      ]
    }
  };
  getConfigShippingMiscCreated(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_CREATED_LABEL',
          controlName: ['createdBy'],
          placeholder: 'GENERIC_CREATED_LABEL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_UPDATED_LABEL',
          controlName: ['updatedBy'],
          placeholder: 'GENERIC_UPDATED_LABEL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }
  getConfigShippingSendingType(): GroupConfig {
    return {
      'config': [
      {
        type: 'select',
        label: 'GENERIC_TYPE',
        controlName: ['type', 'id'],
        placeholder: 'GENERIC_TYPE',
        data: 'typeOfShipping',
        options: {
          show: true,
          value: 'id',
          vue: 'name',
          labelShowInDetail: true
        },
        presentation: 'edit',
      },
      {
          type: 'select',
          label: 'TYPE_OF_SHIPPING_TRANSPORTER',
          controlName: ['transporter', 'id'],
          placeholder: 'TYPE_OF_SHIPPING_TRANSPORTER',
          data: 'transporters',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit',
      },
      {
          type: 'input',
          label: 'ORDERS_LIST_SHIPPING_TRACKING',
          controlName: ['tracking'],
          placeholder: 'ORDERS_LIST_SHIPPING_TRACKING',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
      },
      {
          type: 'input',
          label: 'GENERIC_REF_NAME',
          controlName: ['name'],
          placeholder: 'GENERIC_REF_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      {
          type: 'datePicker',
          label: 'ORDERS_LIST_FILTER_PICKUP_DATE',
          controlName: ['pickupDate'],
          placeholder: 'ORDERS_LIST_PICKUP_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: true,
              useCurrent: false,
              defaultDate: true,
              numberDelayDays: 0,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'edit'
      },
      {
          type: 'datePicker',
          label: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          controlName: ['deliveryDate'],
          placeholder: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: true,
              useCurrent: false,
              numberDelayDays: 1,
              defaultDate: true,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'edit'
      },
      {
          type: 'input',
          label: 'ORDERS_LIST_SHIPPING_DELIVERY_STATUS',
          controlName: ['deliveryStatus'],
          placeholder: 'ORDERS_LIST_SHIPPING_DELIVERY_STATUS',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
      }
      ]
    }

  }

  getConfigShippingBilling(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'SHIPPINGS_EDIT_TITLE_BILLING_COST',
          controlName: ['cost'],
          placeholder: 'SHIPPINGS_EDIT_TITLE_BILLING_COST',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            inputType: {
              type: 'number',
              step: 1
            }
          }
        },
        {
          type: 'input',
          label: 'SHIPPINGS_EDIT_TITLE_BILLING_TAX',
          controlName: ['tax'],
          placeholder: 'SHIPPINGS_EDIT_TITLE_BILLING_TAX',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            inputType: {
              type: 'number',
              step: 1
            }
          }
        },
        {
          type: 'select',
          label: 'SHIPPINGS_EDIT_TITLE_BILLING_CODE',
          controlName: ['analyticCode', 'id'],
          placeholder: 'SHIPPINGS_EDIT_TITLE_BILLING_CODE',
          data: 'analyticCode',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit',
        },
        {
          type: 'select',
          label: 'GENERIC_OFFICE_LABEL',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE_LABEL',
          data: 'office',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit',
        },
        {
          type: 'input',
          label: 'SHIPPINGS_EDIT_TITLE_BILLING_INVOICE',
          controlName: ['invoice'],
          placeholder: 'SHIPPINGS_EDIT_TITLE_BILLING_INVOICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        }
      ]
    }
  }
  getConfigShippingGeneral  (): GroupConfig {
    return {
      'config': [
        {
          type: 'typeAhead',
          label: 'GENERIC_CLIENT',
          controlName: ['clientName', 'clientUuid'],
          placeholder: 'GENERIC_CLIENT',
          data: 'clients',
          options: {
            show: true,
            value: 'uuid',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'typeAhead',
          label: 'GENERIC_SITE',
          controlName: [ 'siteName', 'siteUuid'],
          placeholder: 'GENERIC_SITE',
          data: 'sites',
          options: {
            show: true,
            value: 'uuid',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  };
  getConfigShippingContact(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_NAME',
          controlName: ['name'],
          placeholder: 'ORDER_FORM_CONTACT_NAME_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_SURNAME',
          controlName: ['surname'],
          placeholder: 'ORDER_FORM_CONTACT_SURNAME_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_PHONE',
          controlName: ['phone'],
          placeholder: 'ORDER_FORM_CONTACT_PHONE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_MOBILE',
          controlName: ['mobile'],
          placeholder: 'ORDER_FORM_CONTACT_MOBILE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_EMAIL',
          controlName: ['email'],
          placeholder: 'ORDER_FORM_CONTACT_EMAIL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_DEPARTMENT',
          controlName: ['department'],
          placeholder: 'ORDER_FORM_CONTACT_DEPARTMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  };
  getConfigwaybill(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'Waybill : ',
          controlName: ['waybill'],
          placeholder: 'waybill',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  };


  getConfigShippingAddress(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_1',
          controlName: ['line1'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_1',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_2',
          controlName: ['line2'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_2',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_3',
          controlName: ['line3'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_3',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_ZIP',
          controlName: ['zip'],
          placeholder: 'ORDER_FORM_ADDRESS_ZIP',
          presentation: 'edit',
          options: {
            show: true,
            shortInput: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_CITY',
          controlName: ['city'],
          placeholder: 'ORDER_FORM_ADDRESS_CITY',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_STATE',
          controlName: ['state'],
          placeholder: 'ORDER_FORM_ADDRESS_STATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_ADDRESS_COUNTRY',
          controlName: ['countryForm', 'name'],
          placeholder: 'ORDER_FORM_ADDRESS_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'SHIPPING_ADDRESS_LABEL',
          controlName: ['addressType'],
          placeholder: 'SHIPPING_ADDRESS_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'checkBox',
          label: 'SHIPPING_ADDRESS_KEEP',
          controlName: ['isSaveAddress'],
          placeholder: 'SHIPPING_ADDRESS_KEEP',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'right'
          }
        },
      ]
    }
  };
}
